import React from 'react';
import ServicePageShell from '../../components/ServicePageShell';
import ConditionsServiceStatic from './ConditionsServiceStatic';

export default function ConditionService() {
  return (
    <ServicePageShell
      strapiApiId="annexe-conditions-service"
      defaultSectionLabel="Annexes"
      defaultTitle="Conditions de Service"
      StaticFallback={ConditionsServiceStatic}
    />
  );
}
